import {Component, Vue} from "vue-property-decorator";

import UIEditor from "@/components/ui-editor/UIEditor.vue"
import DZModelInfo from "@/views/资讯管理/model/DZModelInfo";
import uploadFile from "@/utils/DZUploadFile";
import nyMessageToast from "@/utils/NYMessageToast";
import DZServiceInfo from "@/views/资讯管理/service/DZServiceInfo";
import nyNetwork from "@/api/nyBaseNetwork";

@Component({
    components: {UIEditor}
})
export default class Index extends Vue {

    m_info = new DZModelInfo();

    s_info = new DZServiceInfo();

    created(){
        this.m_info.id = this.$route.query.id as string;
        if(this.m_info.id && this.m_info.id != "" ){
            this.action_get_info(this.m_info.id)
        }
        this.s_info.net_all_type()
    }

    action_get_info(id){
        this.net_get_info(id)
    }

    net_get_info(id){
        nyNetwork.net("资讯详情",{id:id}, data => {
            this.m_info = data
            if (this.m_info.listCoverId) {
                this.m_info.imageUrl = nyNetwork.image(this.m_info.listCoverId);
            }
        })
    }

    action_editor_change(text){
        this.m_info.content = text
    }
    action_select_file(file) {
        this.m_info.imageUrl = URL.createObjectURL(file.raw);
        if (file.status == "ready") {
            uploadFile.uploadImage(file.raw,
                (res) => {

                }, (res) => {
                    nyMessageToast.success("图片上传成功")
                    this.m_info.listCoverId = res + "";
                    this.$forceUpdate()
                }, (res) => {
                    nyMessageToast.error("图片上传失败")
                    this.m_info.listCoverId = "";
                    this.$forceUpdate()
                });
        }
    }

    action_add_or_edit(){
        if (this.m_info.id && this.m_info.id != '') {
            this.s_info.net_edit_info(this.m_info,() => {
                this.$router.go(-1);
            });
        } else {
            this.s_info.net_add_info(this.m_info,() => {
                this.$router.back();
            });
        }
    }
}